<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">센터관리</span>
            <span class="txt">센터의 이름, 주소, 전화번호 등 센터의 기본정보를 설정합니다.</span>
        </div>

        <div class="com-table-top">
            <div class="logo-area">
                <div class="logo-box">
                    <span class="logo">
                        <img :src="data.logoUrl" alt="" />
                    </span>
                </div>
                <div class="info-box">
                    <span class="location">{{ data.centerName }}</span>
                    <span class="address">
                        {{ data.address }} {{ data.addressDetail }} /
                        {{ `${data.telNo1 || ''}-${data.telNo2 || ''}-${data.telNo3 || ''}` }}
                    </span>
                    <span v-if="data.centerType == 'M'" class="type">본사</span>
                    <span v-else class="type">지점</span>
                </div>
            </div>
        </div>

        <div class="com-tab">
            <span v-for="(item, index) in submenus" :key="index">
                <router-link :class="{ on: $route.name == item.name }" :to="{ ...item, params: { centerId } }">
                    {{ item.label }}
                </router-link>
            </span>
        </div>

        <p class="sub-title">센터 기본정보</p>

        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: 100px" />
                    <col style="width: 180px" />
                    <col style="width: 470px" />
                    <col style="width: 130px" />
                    <col style="width: 240px" />
                    <col style="width: 200px" />
                    <col style="width: 100px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>계약일</button>
                        </th>
                        <th>
                            <button>계약유형</button>
                        </th>
                        <th>
                            <button>항목</button>
                        </th>
                        <th>
                            <button>서비스명</button>
                        </th>
                        <th></th>
                        <th>
                            <button>사용기간</button>
                        </th>
                        <th>
                            <button>계약금액</button>
                        </th>
                        <th>
                            <button>계약상태</button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in contract" :key="index">
                        <td>{{ item.cp_contract_dt | timestampFilter }}</td>
                        <td>{{ item.cp_ft_prod_type_cd == 'M' ? '월' : '선' }} 결제</td>
                        <td>{{ productTypes[item.cp_ft_prod_type_cd] }}</td>
                        <td>{{ item.cp_ft_prod_nm }}</td>
                        <!-- <td>{{ item.contractMonth }}개월</td> -->
                        <td>
                            <router-link
                                v-if="item.cp_ft_prod_type_cd === 'P' || item.cp_ft_prod_type_cd === 'M'"
                                :to="{
                                    name: 'SettingCenterProgramExtension',
                                    params: {
                                        centerId,
                                        contractId: item.cp_ft_contract_id,
                                        productId: item.cp_ft_prod_id,
                                    },
                                }"
                                class="com-btn-small blue"
                            >
                                연장
                            </router-link>
                        </td>
                        <td>
                            <span
                                v-if="item.cp_ft_prod_type_cd === 'P' || item.cp_ft_prod_type_cd === 'M'"
                                class="info-line"
                            >
                                <span>
                                    {{ item.cp_contract_start_dt | timestampFilter }} ~
                                    {{ item.cp_contract_end_dt | timestampFilter }}
                                </span>
                                <span v-if="item.isEndContract" class="red">사용종료</span>
                                <span v-else class="black">{{ getUseDuration(item.cp_contract_end_dt) }}일 남음</span>
                            </span>
                        </td>
                        <td>
                            {{ item.cp_ft_prod_buy_price | numberFormatFilter }}원
                            <span v-if="item.cp_ret_yn" class="red">
                                ({{ item.cp_ret_exec_dt | timestampFilter }} 환불
                                {{ item.cp_ret_price | numberFormatFilter }}원)
                            </span>
                        </td>
                        <td>{{ item.cp_contract_status_cd == 'O' ? '유효' : '종료' }}</td>
                    </tr>
                    <tr v-if="contract.length == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>

            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
            <!-- <div class="sort-bottom-area">
                <select-form
                    :select-data="['10줄보기', '20줄보기', '50줄보기', '100줄보기']"
                    @update:set="val => (value = val)"
                    class="float-right"
                ></select-form>
            </div> -->
        </div>
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import moment from 'moment';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'SettingCenterProgram',
    components: { LoadingSpinner },
    props: ['centerId'],
    computed: {},
    data() {
        return {
            isLoading: false,
            data: {},
            contract: '',
            productTypes: {},
            submenus: [
                { name: 'SettingCenterEdit', label: '기본정보' },
                { name: 'SettingCenterProgram', label: '프로그램 가입내역' },
                { name: 'SettingCenterHoliday', label: '휴일설정' },
                { name: 'SettingCenterAccount', label: '정산설정' },
                { name: 'SettingCenterPaymentList', label: '결제내역' },
                { name: 'SettingCenterPaymentMethod', label: '결제수단' },
                { name: 'SettingCenterFitpay', label: '핏페이' }, // TESTING ON PROD
                // { name: 'SettingCenterLecture', label: '교차수강설정' },
            ],
            pagingInfo: { ...pagingInfo },
        };
    },
    async beforeMount() {
        (await this.$getSystemCode({ ft_contract_prod: ['ft_prod_type_cd'] })).forEach((o) => {
            o.forEach((e) => {
                this.productTypes[e.codeName] = e.codeDesc;
            });
        });
    },
    mounted() {
        this.load();
        this.loadProduct();
    },
    methods: {
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.loadProduct();
        },
        load() {
            if (!this.centerId) return;
            this.isLoading = true;
            api.get(`/admin/api/center/${this.centerId}`)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data;
                    this.data.telNo = (this.data.telNo || '').match(/(\d{2,3})(\d{3,4})(\d{4})/);
                    if (this.data.telNo) {
                        this.data.telNo1 = this.data.telNo[1];
                        this.data.telNo2 = this.data.telNo[2];
                        this.data.telNo3 = this.data.telNo[3];
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                    this.data = {};
                    if (res.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        loadProduct() {
            api.get(`/admin/api/ft/contract/contract-product/center/${this.centerId}`, {
                params: { ...this.pagingInfo },
            })
                .then((res) => {
                    this.isLoading = false;
                    this.setPageParams(res.data);
                    this.contract = res.data.items;
                    this.contract.forEach((item) => {
                        item.isEndContract = moment().isAfter(item.cp_contract_end_dt);
                    });
                    console.log(this.contract);
                    this.$forceUpdate();
                })
                .catch((res) => {
                    this.isLoading = false;
                    for (const key in res) console.log(key, res[key]);
                    if (res.status != 404) alert(`오류가 발생했습니다.\n${res.message}`);
                    console.error(res);
                });
        },
        getUseDuration(date) {
            return Math.floor(moment.duration(moment(date).diff(moment())).asDays());
        },
    },
};
</script>
<style lang="scss"></style>
